(function () {
  if (window.__swA11yLoaded) { return; }
  window.__swA11yLoaded = true;
  var ITEM = '.sw-instagram-item';
  var MODAL = '.sw-instagram-modal';
  var lastTrigger = null;
  var lastIndex = 0;
  var wasActive = false;
  var watched = null;
  var modalObserver = null;
  var scanPending = 0;
  var modalPending = 0;
  var note = null;

  function oneLine(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function firstLine(text, max) {
    var line = oneLine((text || '').split('\n').filter(function (l) { return l.trim(); })[0]);
    if (line.length <= max) { return line; }
    var cut = line.slice(0, max);
    var space = cut.lastIndexOf(' ');
    return (space > 40 ? cut.slice(0, space) : cut) + '…';
  }

  function onKeyActivate(el, withSpace) {
    el.addEventListener('keydown', function (e) {
      if (e.target !== el) { return; }
      if (e.key === 'Enter' || (withSpace && e.key === ' ')) {
        e.preventDefault();
        el.click();
      }
    });
  }

  function makeButton(el, label) {
    if (!el || el.getAttribute('data-a11y-button')) { return; }
    el.setAttribute('data-a11y-button', '1');
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-label', label);
    onKeyActivate(el, true);
  }

  function enhanceItem(item, index) {
    item.setAttribute('data-a11y-enhanced', '1');
    var caption = item.querySelector('.sw-instagram-item-overlay-caption');
    var date = item.querySelector('.sw-instagram-item-overlay-date');
    var text = firstLine(caption && caption.textContent, 90);
    var when = oneLine(date && date.textContent);
    var label = 'Open Instagram post' + (text ? ': ' + text : ' ' + (index + 1)) + (when ? ', ' + when : '');
    item.setAttribute('role', 'button');
    item.setAttribute('tabindex', '0');
    item.setAttribute('aria-haspopup', 'dialog');
    item.setAttribute('aria-label', label);
    onKeyActivate(item, true);
  }

  function ensureNote(modal) {
    if (note && modal.contains(note)) { return note; }
    note = document.createElement('span');
    note.setAttribute('aria-live', 'polite');
    note.setAttribute('aria-atomic', 'true');
    note.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0;';
    modal.appendChild(note);
    return note;
  }

  function announcePost(modal) {
    window.setTimeout(function () {
      var caption = modal.querySelector('.sw-popup-info-caption');
      var text = firstLine(caption && caption.textContent, 90);
      var n = ensureNote(modal);
      n.textContent = '';
      window.setTimeout(function () { n.textContent = text ? 'Instagram post: ' + text : 'Instagram post'; }, 60);
    }, 350);
  }

  function enhanceModal(modal) {
    if (modal.getAttribute('role') !== 'dialog') { modal.setAttribute('role', 'dialog'); }
    if (modal.getAttribute('aria-modal') !== 'true') { modal.setAttribute('aria-modal', 'true'); }
    if (modal.getAttribute('aria-label') !== 'Instagram post') { modal.setAttribute('aria-label', 'Instagram post'); }
    makeButton(modal.querySelector('.sw-instagram-modal-close'), 'Close');
    var prev = modal.querySelector('.sw-instagram-modal-nav-prev');
    var next = modal.querySelector('.sw-instagram-modal-nav-next');
    makeButton(prev, 'Previous post');
    makeButton(next, 'Next post');
    [prev, next].forEach(function (nav) {
      if (nav && !nav.getAttribute('data-a11y-announce')) {
        nav.setAttribute('data-a11y-announce', '1');
        nav.addEventListener('click', function () { announcePost(modal); });
      }
    });
    var images = modal.querySelectorAll('img');
    Array.prototype.forEach.call(images, function (img, i) {
      var alt = img.getAttribute('alt') || '';
      if (alt.length > 125) {
        img.setAttribute('alt', 'Instagram post image ' + (i + 1) + ' of ' + images.length);
      }
    });
  }

  function focusables(modal) {
    return Array.prototype.filter.call(
      modal.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]'),
      function (el) {
        var r = el.getBoundingClientRect();
        return (r.width > 0 || r.height > 0) && getComputedStyle(el).visibility !== 'hidden';
      }
    );
  }

  function onModalKeydown(e) {
    var modal = watched;
    if (!modal || !modal.classList.contains('is-active')) { return; }
    if (e.key === 'Escape') {
      var close = modal.querySelector('.sw-instagram-modal-close');
      if (close) { e.preventDefault(); close.click(); }
      return;
    }
    if (e.key !== 'Tab') { return; }
    var list = focusables(modal);
    if (!list.length) { return; }
    var first = list[0];
    var last = list[list.length - 1];
    var current = document.activeElement;
    if (!modal.contains(current)) {
      e.preventDefault();
      first.focus();
    } else if (e.shiftKey && current === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && current === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function restoreFocus() {
    wasActive = false;
    var target = lastTrigger && document.contains(lastTrigger) ? lastTrigger : document.querySelectorAll(ITEM)[lastIndex];
    if (target) { target.focus(); }
  }

  function syncModal() {
    modalPending = 0;
    var modal = watched;
    if (!modal || !document.contains(modal)) { return; }
    var active = modal.classList.contains('is-active');
    if (active) {
      enhanceModal(modal);
      if (!wasActive) {
        wasActive = true;
        window.setTimeout(function () {
          var close = modal.querySelector('.sw-instagram-modal-close');
          if (close) { close.focus(); }
        }, 80);
      }
    } else if (wasActive) {
      restoreFocus();
    }
  }

  function scheduleModalSync() {
    if (modalPending) { return; }
    modalPending = window.setTimeout(syncModal, 30);
  }

  function scan() {
    scanPending = 0;
    var items = document.querySelectorAll(ITEM);
    Array.prototype.forEach.call(items, function (item, i) {
      if (!item.getAttribute('data-a11y-enhanced')) { enhanceItem(item, i); }
    });
    if (watched && !document.contains(watched)) {
      if (modalObserver) { modalObserver.disconnect(); }
      watched = null;
      if (wasActive) { restoreFocus(); }
    }
    var modal = document.querySelector(MODAL);
    if (modal && modal !== watched) {
      watched = modal;
      if (modalObserver) { modalObserver.disconnect(); }
      modalObserver = new MutationObserver(scheduleModalSync);
      modalObserver.observe(modal, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
      scheduleModalSync();
    }
  }

  function scheduleScan() {
    if (scanPending) { return; }
    scanPending = window.setTimeout(scan, 30);
  }

  document.addEventListener('click', function (e) {
    var item = e.target && e.target.closest ? e.target.closest(ITEM) : null;
    if (item) {
      lastTrigger = item;
      lastIndex = Array.prototype.indexOf.call(document.querySelectorAll(ITEM), item);
    }
  }, true);
  document.addEventListener('keydown', onModalKeydown, true);

  if (window.MutationObserver) {
    new MutationObserver(scheduleScan).observe(document.body, { childList: true, subtree: true });
  }
  scan();
})();
